import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { useRealtime } from '@/lib/ws/useRealtime'

// crm.access.*: erişim kararı müşteri görünürlüğünü değiştirir, tüm CRM sorguları tazelenir.
const PREFIXES = ['meeting.', 'followup.due', 'crm.payment.', 'quote.accepted', 'order.approved', 'crm.access.']

// Router bu bileşenin dışında kurulur; doğrudan import döngüsel bağımlılık yaratacağı için tıklamada yüklenir.
const openAccess = () => void import('@/app/router').then((m) => m.router.navigate('/customers/access'))

type AccessEventData = { status?: string; body?: string }

export function useCrmRealtime() {
  const qc = useQueryClient()
  const { t } = useTranslation()
  useRealtime(
    (event) => PREFIXES.some((p) => event.startsWith(p)),
    (msg) => {
      void qc.invalidateQueries({ queryKey: ['crm'] })
      const data = (msg.data ?? {}) as AccessEventData
      const action = { label: t('crm.access.live.open'), onClick: openAccess }
      if (msg.event === 'crm.access.requested') {
        toast.info(t('crm.access.live.requested'), { description: data.body, action })
      } else if (msg.event === 'crm.access.decided' && (data.status === 'approved' || data.status === 'rejected' || data.status === 'revoked')) {
        const show = data.status === 'approved' ? toast.success : toast.error
        show(t(`crm.access.live.${data.status}`), { description: data.body, action })
      }
    },
  )
}

export function CrmRealtime() {
  useCrmRealtime()
  return null
}
